export enum ExpressionOperation {
  Like = 1,
  NotLike = 2,
  Equal = 3,
  NotEqual = 4,
}
